import graphql__6e0eb0eb436e456ca09a from "./__generated__/PageSectionSidebarLinkBlock_pageSection.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";
import classNames from "classnames";

import ButtonLink from "../Buttons/ButtonLink";
import Icon from "../Utils/Icon";

const PageSectionSidebarLinkBlock = props => {
  const { url, title, subtitle, iconClass } = props.pageSection;

  if (!url) return null;

  const iconClassName = classNames(["text-primary", "text-sign-sm", iconClass]);

  return (
    <div className="container page-section">
      <ButtonLink
        className="page-section-link-block padding-md box d-block text-primary-hover box-shadow"
        href={url}
      >
        <span className="page-section-link-block-inner">
          <span className="with-icon text-btn-lg">
            <Icon className={iconClassName} />

            <span className="with-icon-text">{title}</span>
          </span>

          <span className="d-block text-subtitle-section">{subtitle}</span>
        </span>
      </ButtonLink>
    </div>
  );
};

export default createFragmentContainer(PageSectionSidebarLinkBlock, {
  pageSection: graphql__6e0eb0eb436e456ca09a
});
